import React from "react"
import {useTranslation} from "react-i18next"
import LinkedInIcon from "../../../resource/icon/linkedin.svg"
import ShareButton from "./ShareButton"

interface LinkedInButtonProps {
  order: number
  shareUrl: string
  trackClick: () => void
}

export default function LinkedInButton({ order, shareUrl, trackClick }: LinkedInButtonProps) {
  const { t } = useTranslation()

  const shareToLinkedIn = () => {
    trackClick()
    let url = encodeURIComponent(shareUrl)
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`)
  }

  return (
    <ShareButton
      order={order}
      onClick={shareToLinkedIn}
      style={{ backgroundColor: "#1472ae" }}
    >
      <img src={LinkedInIcon} style={{height: "30px", top: "20px", left: "78px"}} />
      {t("shareSheet.buttons.linkedIn")}
    </ShareButton>
  )
}